module.exports = __webpack_public_path__ + "media/images/muscles-a15a9a45d2528fffd96f51f670469e35.svg";